const Style = {

  // Wrapper – actions | bell | avatar
  user: 'flex items-center gap-2',

  // ── Quick actions button ──────────────────────
  actionBtn: [
    'relative flex items-center justify-center flex-shrink-0',
    'w-9 h-9 rounded-xl border border-amber-300',
    'text-amber-700 bg-amber-50 hover:bg-amber-100',
    'shadow-sm transition-all duration-150 cursor-pointer',
  ].join(' '),

  actionsDropdown: [
    'absolute right-0 top-11 z-50',
    'w-52 bg-white',
    'rounded-2xl shadow-xl',
    'border border-slate-100',
    'overflow-hidden',
    'py-2',
  ].join(' '),

  actionsDropItem: [
    'w-full flex items-center gap-3',
    'px-4 py-2.5 text-left',
    'text-sm font-medium text-slate-600',
    'hover:bg-amber-50 hover:text-amber-700',
    'transition-colors',
  ].join(' '),

  actionsDropIcon: [
    'w-4 h-4 flex-shrink-0 text-amber-500',
  ].join(' '),

  // ── Notification bell ────────────────────────────
  bellBtn: [
    'relative flex items-center justify-center flex-shrink-0',
    'w-9 h-9 rounded-xl border border-slate-200 bg-white',
    'text-slate-500 shadow-sm',
    'hover:border-amber-300 hover:bg-amber-50 hover:text-amber-600',
    'transition-all duration-150 cursor-pointer',
  ].join(' '),

  bellBtnActive: [
    'relative flex items-center justify-center flex-shrink-0',
    'w-9 h-9 rounded-xl border-2 border-amber-400 bg-amber-50',
    'text-amber-600 shadow-sm shadow-amber-100',
    'hover:bg-amber-100',
    'transition-all duration-150 cursor-pointer',
  ].join(' '),

  badge: [
    'absolute -top-1 -right-1',
    'min-w-[18px] h-[18px] px-1',
    'bg-red-500 text-white',
    'text-[10px] font-bold leading-[18px] text-center',
    'rounded-full',
    'ring-2 ring-white',
  ].join(' '),

  // ── Notification dropdown ─────────────────────────
  dropdown: [
    'absolute right-0 top-12 z-50',
    'w-80 bg-white',
    'rounded-2xl shadow-xl',
    'border border-slate-100',
    'overflow-hidden',
  ].join(' '),

  dropHeader: [
    'flex items-center justify-between',
    'px-4 py-3.5',
    'bg-slate-50 border-b border-slate-100',
  ].join(' '),

  dropTitle: 'text-sm font-bold text-slate-700',

  markAllBtn: [
    'text-xs text-amber-600 hover:text-amber-700 font-semibold',
    'transition-colors',
  ].join(' '),

  dropList: 'max-h-80 overflow-y-auto divide-y divide-slate-50',

  emptyText: 'text-center text-sm text-slate-400 py-8',

  dropItem: [
    'w-full flex gap-3 px-4 py-3 text-left',
    'hover:bg-slate-50 transition-colors',
  ].join(' '),

  dropItemUnread: 'bg-amber-50/40 hover:bg-amber-50',

  dropItemDot: 'flex-shrink-0 w-2 flex items-start pt-1.5',

  unreadDot: 'block w-2 h-2 rounded-full bg-amber-400',

  dropItemBody: 'flex-1 min-w-0',

  dropItemTitle: 'text-sm font-semibold text-slate-700 truncate',

  dropItemText: [
    'text-xs text-slate-500 mt-0.5',
    'line-clamp-2 leading-relaxed',
  ].join(' '),

  dropItemTime: 'text-[10px] text-slate-400 font-medium mt-1',

  // ── Avatar pill ──────────────────────────────────
  avatarWrap: [
    'flex items-center gap-2.5 cursor-pointer select-none',
    'bg-white border border-slate-200 shadow-sm',
    'rounded-xl pl-1 pr-3.5 py-1.5',
    'hover:border-indigo-300 hover:shadow-md',
    'transition-all duration-150',
  ].join(' '),

  avatar: [
    'w-[36px] h-[36px] rounded-full flex-shrink-0',
    'flex items-center justify-center',
    'text-sm font-bold text-white',
    'ring-2 ring-white',
  ].join(' '),

  avatarInfo: 'hidden md:flex flex-col leading-none',

  avatarName: 'text-[13px] font-bold text-slate-800 leading-tight whitespace-nowrap',

  avatarRole: [
    'text-[10px] font-semibold leading-tight mt-0.5 whitespace-nowrap',
    'text-indigo-400 tracking-wide uppercase',
  ].join(' '),

  // ── Chevron inside avatar pill ───────────────────
  avatarChevron: 'hidden md:block w-3 h-3 text-slate-400 flex-shrink-0',

  // ── User dropdown (profile menu) ───────────────
  userDropdown: [
    'absolute right-0 top-12 z-50',
    'w-72 bg-white',
    'rounded-2xl shadow-xl',
    'border border-slate-100',
    'overflow-hidden',
  ].join(' '),

  userDropHeader: [
    'flex items-center gap-3',
    'px-4 py-4',
    'bg-gradient-to-br from-indigo-600 to-indigo-800',
  ].join(' '),

  userDropMeta: 'flex flex-col min-w-0 overflow-hidden',

  userDropName: 'text-sm font-bold text-white leading-snug break-words',

  userDropRole: 'text-xs text-indigo-200 font-medium mt-0.5',

  userDropSection: [
    'py-1.5',
    'border-b border-slate-50 last:border-b-0',
  ].join(' '),

  userDropSectionLabel: [
    'block text-[10px] font-semibold text-slate-400 uppercase tracking-wider',
    'px-4 pt-2 pb-1',
  ].join(' '),

  userDropItem: [
    'w-full text-left text-sm text-slate-600',
    'px-4 py-2.5',
    'hover:bg-slate-50 hover:text-slate-800',
    'transition-colors flex items-center gap-2.5',
  ].join(' '),

  userDropItemActive: 'text-indigo-600 font-semibold',

  // Separator between action groups in header
  headerSep: 'w-px h-6 bg-slate-200 mx-0.5',

}

export default Style;
